import { useEffect } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { InspectionTemplate } from 'inspection-types';

type Params = {
  template: InspectionTemplate | undefined;
  setExpandedBySectionId: Dispatch<
    SetStateAction<Record<string, boolean>>
  >;
  setActiveSectionId: Dispatch<SetStateAction<string | null>>;
};

export function useInspectionTemplateCustomizeExpandedState({
  template,
  setExpandedBySectionId,
  setActiveSectionId,
}: Params): void {
  useEffect(() => {
    if (!template) {
      return;
    }

    const next: Record<string, boolean> = {};
    const sorted = [...template.sections].sort((a, b) => a.order - b.order);

    for (const section of sorted) {
      next[section.id] = !section.config?.collapsedByDefault;
    }

    setExpandedBySectionId(next);

    if (sorted[0]) {
      setActiveSectionId(sorted[0].id);
    }
  }, [template, setExpandedBySectionId, setActiveSectionId]);
}
